/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_TSPAY_RECEIVE,
    CURRENT_TSPAY_REQUEST,
    CURRENT_TSPAY_REQUEST_SUCCESS,
    CURRENT_TSPAY_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_TSPAY_REQUEST]: () => true,
    [CURRENT_TSPAY_REQUEST_SUCCESS]: () => false,
    [CURRENT_TSPAY_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_TSPAY_RECEIVE]: (state, action) => action.payload.tsPay,
});

export const error = createReducer(false, {
    [CURRENT_TSPAY_REQUEST]: () => false,
    [CURRENT_TSPAY_REQUEST_SUCCESS]: () => false,
    [CURRENT_TSPAY_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
